<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Port Areas'"
      :fields="[{ header: 'Name', prop: 'name' }]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'PortAreaSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [{ header: 'Name', prop: 'name' }],
        loading: false,
        tableData: [],
        entityName: 'port-area',
        editEntityScreen: 'Admin - Edit/View Port Area'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// PortAreaSearchResults.vue?7f6b1ff4